import { render, staticRenderFns } from "./SiteCandidates.vue?vue&type=template&id=38013478&scoped=true"
import script from "./SiteCandidates.vue?vue&type=script&lang=js"
export * from "./SiteCandidates.vue?vue&type=script&lang=js"
import style0 from "./SiteCandidates.vue?vue&type=style&index=0&id=38013478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38013478",
  null
  
)

export default component.exports